import React from "react";
import MembersApi from '../../../../services/portal-api/MembersApi';
import { RiRestartFill } from "react-icons/ri";

class RestartQueue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: "",
            msg: null,
            restart: false,
            isLoading: false,
        }
    }

    restartQueue = () => {
        swal({
            title: "Are you sure?",
            text: "you want to restart the queue",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: ["Cancel", "Proceed"],
        }).then((willDelete) => {
            if (willDelete) {
                this.setState({ 
                    restart: true 
                }, () => {
                    MembersApi.restartQ((result) => {
                        if (result.success) {
                            if (result.json.success) {

                                swal("Queue restarted successfully", {
                                    icon: "success",
                                    buttons: false,
                                    timer: 3000
                                });
                            } else {
                                swal("Restart failed :" + result.json.error, {
                                    icon: "warning",
                                    buttons: false,
                                    timer: 3000
                                });
                            }
                        } else {
                            this._sessionLoadOut(result);
                        }
                    });
                });
            }
        });
    }

    _sessionLoadOut = (response) => {
        if (response.status === 401) {
            this.props.sessionExpired();
            this.setState({
                isLoading: false,
            });
            return;
        } else {
            swal("Something went wrong", {
                icon: "warning",
                buttons: false,
                timer: 3000
            });

            this.setState({
                isLoading: false,
                restart: false 
            });

            return;
        }
    }

    render() {
        let queue_status = this.state.restart ? "Restarting" : "Restart";
        return (
            <button style={{marginBottom: '10px'}} className="btn btn--small btn--open btn--blue" onClick={this.restartQueue} data-id="queue">{queue_status} {this.state.restart && <img className="icon" src="/img/Gear-job.gif" style={{ width: 20, height: 20, top: "34%", marginTop: -5, right: 8 }}></img>}</button>
        )
    }

}

export default RestartQueue;